var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 440,
    height: 460,
    viewBox: "0 0 440 460",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 460
  })))), /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1394.518 -234)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43.221,
    height: 334.539,
    transform: "translate(1616.33 296.578)",
    fill: "#9bc1f9",
    opacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 43.22,
    height: 232.497,
    transform: "translate(1555.97 398.62)",
    fill: "#9bc1f9",
    opacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 43.22,
    height: 262.058,
    transform: "translate(1677.558 369.059)",
    fill: "#9bc1f9",
    opacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 43.221,
    height: 272.364,
    transform: "translate(1495.61 358.753)",
    fill: "#9bc1f9",
    opacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 43.221,
    height: 191.609,
    transform: "translate(1435.25 439.508)",
    fill: "#9bc1f9",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1435.25 373.68)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.221,
    height: 257.437,
    transform: "translate(181.079 0)",
    fill: "#9bc1f9",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.22,
    height: 178.913,
    transform: "translate(120.72 78.524)",
    fill: "#9bc1f9",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.22,
    height: 201.661,
    transform: "translate(242.308 55.776)",
    fill: "#9bc1f9",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.221,
    height: 209.592,
    transform: "translate(60.36 47.845)",
    fill: "#9bc1f9",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.221,
    height: 147.449,
    transform: "translate(0 109.988)",
    fill: "#9bc1f9",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1742.027,308.447l-34.44,26.047,13.137.838-82.212,144.692-45.52-68.246-64.393,150.2-41.419-58.829-51.624,72.974,3.248,13.061,48.353-68.02,43.782,62.186L1595.1,433.7l44.166,66.215,91.018-160.19,8.45,9.088Z",
    transform: "translate(-0.241 -9.309)",
    fill: "#5183bf"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1634.842 604.582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2496.15,1748.316v16.816c0,2.719-30.327,4.922-67.737,4.922s-67.738-2.2-67.738-4.922v-16.816Z",
    transform: "translate(-2360.675 -1743.215)",
    fill: "#e59f39"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2761.529,1769.864v-21.548h49.021v16.816C2810.549,1767.379,2789.836,1769.274,2761.529,1769.864Z",
    transform: "translate(-2675.074 -1748.316)",
    fill: "#eab054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2603.95,1769.908c-5.262.1-10.768.146-16.436.146-8.446,0-16.531-.112-23.987-.317v-21.421h40.423Z",
    transform: "translate(-2519.777 -1748.316)",
    fill: "#eab054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2401.711,1769.657c-24.134-.753-41.036-2.5-41.036-4.525v-16.816h41.036Z",
    transform: "translate(-2360.675 -1748.316)",
    fill: "#eab054"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.737,
    cy: 4.922,
    rx: 67.737,
    ry: 4.922,
    transform: "translate(0 0)",
    fill: "#e59f39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2416.115,1735.078c0,1.885,24.974,3.413,55.781,3.413s55.781-1.528,55.781-3.413-24.974-3.413-55.781-3.413S2416.115,1733.193,2416.115,1735.078Z",
    transform: "translate(-2404.157 -1730.155)",
    fill: "#f7cc7f"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1646.431 586.788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2549.884,1665.811v16.816c0,2.719-30.327,4.922-67.738,4.922s-67.738-2.2-67.738-4.922v-16.816Z",
    transform: "translate(-2414.409 -1660.71)",
    fill: "#e59f39"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2815.264,1687.359v-21.548h49.021v16.816C2864.284,1684.874,2843.571,1686.769,2815.264,1687.359Z",
    transform: "translate(-2728.809 -1665.811)",
    fill: "#eab054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2657.684,1687.4c-5.262.095-10.767.146-16.436.146-8.446,0-16.531-.112-23.987-.318v-21.42h40.423Z",
    transform: "translate(-2573.511 -1665.811)",
    fill: "#eab054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2455.445,1687.152c-24.134-.753-41.037-2.5-41.037-4.525v-16.816h41.037Z",
    transform: "translate(-2414.409 -1665.811)",
    fill: "#eab054"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.738,
    cy: 4.922,
    rx: 67.738,
    ry: 4.922,
    transform: "translate(0 0)",
    fill: "#e59f39"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.78,
    cy: 3.413,
    rx: 55.78,
    ry: 3.413,
    transform: "translate(11.957 1.51)",
    fill: "#f7cc7f"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1638.71 568.521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2514.082,1581.113v16.816c0,2.718-30.327,4.922-67.737,4.922s-67.738-2.2-67.738-4.922v-16.816Z",
    transform: "translate(-2378.607 -1576.012)",
    fill: "#e59f39"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2779.463,1602.661v-21.548h49.021v16.816C2828.483,1600.176,2807.769,1602.071,2779.463,1602.661Z",
    transform: "translate(-2693.008 -1581.113)",
    fill: "#eab054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2621.883,1602.705c-5.262.1-10.768.146-16.435.146-8.446,0-16.531-.112-23.988-.317v-21.421h40.423Z",
    transform: "translate(-2537.709 -1581.113)",
    fill: "#eab054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2419.643,1602.454c-24.133-.753-41.036-2.5-41.036-4.525v-16.816h41.036Z",
    transform: "translate(-2378.607 -1581.113)",
    fill: "#eab054"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.737,
    cy: 4.922,
    rx: 67.737,
    ry: 4.922,
    transform: "translate(0 0)",
    fill: "#e59f39"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.78,
    cy: 3.413,
    rx: 55.78,
    ry: 3.413,
    transform: "translate(11.957 1.51)",
    fill: "#f7cc7f"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1646.431 550.504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2549.884,1497.576v16.816c0,2.718-30.327,4.922-67.738,4.922s-67.738-2.2-67.738-4.922v-16.816Z",
    transform: "translate(-2414.409 -1492.475)",
    fill: "#e59f39"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2815.264,1519.124v-21.548h49.021v16.816C2864.284,1516.638,2843.571,1518.534,2815.264,1519.124Z",
    transform: "translate(-2728.809 -1497.576)",
    fill: "#eab054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2657.684,1519.168c-5.262.1-10.767.146-16.436.146-8.446,0-16.531-.112-23.987-.317v-21.421h40.423Z",
    transform: "translate(-2573.511 -1497.576)",
    fill: "#eab054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2455.445,1518.917c-24.134-.753-41.037-2.5-41.037-4.525v-16.816h41.037Z",
    transform: "translate(-2414.409 -1497.576)",
    fill: "#eab054"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.738,
    cy: 4.922,
    rx: 67.738,
    ry: 4.922,
    transform: "translate(0 0)",
    fill: "#e59f39"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.78,
    cy: 3.413,
    rx: 55.78,
    ry: 3.413,
    transform: "translate(11.957 1.51)",
    fill: "#f7cc7f"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1694.894 501.714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2757.641,1283.618l-4.069,14.206c-.658,2.3-26.811-3.18-58.415-12.233s-56.691-18.253-56.033-20.549l4.069-14.206Z",
    transform: "translate(-2639.111 -1250.162)",
    fill: "#e59f39"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2972.5,1366.036l5.214-18.2,41.413,11.862-4.07,14.206C3014.512,1375.8,2996.555,1372.387,2972.5,1366.036Z",
    transform: "translate(-2900.595 -1326.913)",
    fill: "#eab054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2839.478,1327.943c-4.468-1.193-9.131-2.482-13.92-3.854-7.135-2.044-13.938-4.095-20.187-6.073l5.184-18.1,34.148,9.781Z",
    transform: "translate(-2769.513 -1289.335)",
    fill: "#eab054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2672.7,1278.794c-20.206-6.476-34.063-12.038-33.572-13.753l4.069-14.206,34.667,9.93Z",
    transform: "translate(-2639.111 -1250.836)",
    fill: "#eab054"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2658.19,1248.233c-.658,2.3,24.429,11.5,56.033,20.549s57.758,14.529,58.416,12.233-24.429-11.5-56.033-20.549S2658.848,1245.937,2658.19,1248.233Z",
    transform: "translate(-2654.065 -1247.71)",
    fill: "#e59f39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2705.045,1262.434c-.456,1.592,20.272,8.926,46.3,16.381s47.493,12.207,47.949,10.615-20.272-8.926-46.3-16.381S2705.5,1260.841,2705.045,1262.434Z",
    transform: "translate(-2690.819 -1259.017)",
    fill: "#f7cc7f"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1662.534 436.761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2603.17,949.5l4.333,14.128c.7,2.284-24.211,11.949-55.64,21.588s-57.477,15.6-58.178,13.317l-4.332-14.128Z",
    transform: "translate(-2489.292 -948.867)",
    fill: "#e59f39"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.06 0.637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2831.678,980.237l-5.552-18.1,41.184-12.63,4.333,14.128C2872.221,965.519,2855.307,972.448,2831.678,980.237Z",
    transform: "translate(-2753.492 -949.504)",
    fill: "#eab054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2699.3,1028.93c-4.4,1.436-9.009,2.9-13.77,4.357-7.1,2.176-13.917,4.165-20.235,5.913l-5.519-18,33.96-10.415Z",
    transform: "translate(-2623.02 -997.572)",
    fill: "#eab054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2529.327,1080.251c-20.47,5.586-35.119,8.476-35.642,6.772l-4.332-14.128,34.476-10.573Z",
    transform: "translate(-2489.352 -1037.99)",
    fill: "#eab054"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2489.086,981.941c.7,2.284,26.747-3.678,58.177-13.317s56.341-19.3,55.641-21.588-26.747,3.678-58.177,13.317S2488.386,979.657,2489.086,981.941Z",
    transform: "translate(-2489.072 -946.549)",
    fill: "#e59f39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2535.685,990.8c.486,1.584,21.861-3.567,47.743-11.5s46.47-15.655,45.984-17.239-21.861,3.567-47.743,11.5S2535.2,989.212,2535.685,990.8Z",
    transform: "translate(-2525.625 -958.484)",
    fill: "#f7cc7f"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1569.317 587.465)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.667,
    height: 43.19,
    transform: "translate(118.667 43.19) rotate(180)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.667,
    height: 5.556,
    transform: "translate(118.667 11.85) rotate(180)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 118.667,
    height: 5.556,
    transform: "translate(118.667 22.703) rotate(180)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 118.667,
    height: 5.556,
    transform: "translate(118.667 33.556) rotate(180)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 118.667,
    height: 5.556,
    transform: "translate(118.667 43.19) rotate(180)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.68,
    height: 43.19,
    transform: "translate(68.855 43.19) rotate(180)",
    fill: "#f7cc7f"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 17.921,
    height: 43.19,
    transform: "translate(135.148 43.19) rotate(180)",
    fill: "#3c8f7c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStocks);
export default __webpack_public_path__ + "static/media/stocks.c028c0f7efc9bc0485337218d1764a50.svg";
export { ForwardRef as ReactComponent };